/* eslint-disable react/require-default-props,react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { scroller } from 'react-scroll';
import {
  PortalQualificationPropType,
  PortalTestimonialsDataPropType,
} from '../../../../CustomPropTypes/PortalPropTypes';
import { Carousel } from '../Carousel/Carousel';
import { PortalCallToAction } from '../PortalCallToAction/PortalCallToAction';
import { PortalJoinQualificationButton } from '../../PortalButton/PortalJoinQualificationButton';
import { LoadableResponsiveImage as ResponsiveImage } from '../../../components/ResponsiveImage/LoadableResponsiveImage';
import './PortalTestimonials.scss';

export class PortalTestimonials extends React.Component {
  static displayName = 'PortalTestimonials';

  static propTypes = {
    pageType: PropTypes.string.isRequired,
    anchor: PropTypes.string.isRequired,
    callToAction: PropTypes.string,
    enrol: PropTypes.func,
    qualification: PortalQualificationPropType,
    testimonials: PortalTestimonialsDataPropType.isRequired,
    onCtaButtonClicked: PropTypes.func,
  };

  onCtaButtonClicked = () => {
    const { pageType, callToAction, enrol, onCtaButtonClicked } = this.props;
    if (pageType === 'institution') {
      if (callToAction && onCtaButtonClicked) {
        onCtaButtonClicked(callToAction);
      }
      scroller.scrollTo('qualifications', { smooth: true, duration: 500 });
    } else if (pageType === 'qualification' && _.isFunction(enrol)) {
      enrol();
    }
  };

  render() {
    const {
      anchor,
      pageType,
      testimonials,
      callToAction,
      qualification,
      onCtaButtonClicked,
    } = this.props;

    const renderCallToAction = () => {
      if (!callToAction) {
        return null;
      }

      if (pageType === 'qualification') {
        return (
          <div className="portal-enrol-button-wrapper">
            <PortalJoinQualificationButton
              {...{ qualification, onCtaButtonClicked }}
              onClick={this.onCtaButtonClicked}
            />
          </div>
        );
      }
      return (
        <PortalCallToAction onClick={this.onCtaButtonClicked}>
          <span>{callToAction}</span>
        </PortalCallToAction>
      );
    };

    return (
      <portal-testimonials id={anchor}>
        <div className="row portal-section">
          <div className="columns small-11 small-centered medium-10 medium-centered">
            <div className="testimonials-outer-container">
              <Carousel>
                {testimonials.map((testimonial, i) => (
                  <div className="testimonial-wrapper" key={i}>
                    <div className="testimonial">
                      <svg
                        className="quote quote-left"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 20 20"
                        display="none"
                      >
                        <path
                          d="M5.315,3.401c-1.61,0-2.916,1.343-2.916,3c0,1.656,1.306,3,2.916,3c2.915,0,0.972,5.799-2.916,5.799v1.4
                        C9.338,16.601,12.057,3.401,5.315,3.401z M13.715,3.401c-1.609,0-2.915,1.343-2.915,3c0,1.656,1.306,3,2.915,3
                        c2.916,0,0.973,5.799-2.915,5.799v1.4C17.738,16.601,20.457,3.401,13.715,3.401z"
                          transform="rotate(180 10 10)"
                        />
                      </svg>
                      <div className="testimonial-person">
                        <ResponsiveImage
                          role="presentation"
                          src={testimonial.get('photoImage')}
                          resize="h:72,w:72"
                        />
                        <h5>
                          <strong>{testimonial.get('name')}</strong>
                          <span>, {testimonial.get('title')}</span>
                          <br />
                          <em>{testimonial.get('organisation')}</em>
                        </h5>
                      </div>
                      <div className="testimonial-quote">
                        {testimonial
                          .get('testimonial')
                          .split('\n')
                          .map((line, lineIndex) => (
                            <span key={`line_${lineIndex}`}>
                              {line} <br />
                            </span>
                          ))}
                      </div>
                      <svg
                        className="quote quote-right"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 20 20"
                        display="none"
                      >
                        <path
                          d="M5.315,3.401c-1.61,0-2.916,1.343-2.916,3c0,1.656,1.306,3,2.916,3c2.915,0,0.972,5.799-2.916,5.799v1.4
                        C9.338,16.601,12.057,3.401,5.315,3.401z M13.715,3.401c-1.609,0-2.915,1.343-2.915,3c0,1.656,1.306,3,2.915,3
                        c2.916,0,0.973,5.799-2.915,5.799v1.4C17.738,16.601,20.457,3.401,13.715,3.401z"
                          transform="rotate(180 10 10) scale(-1,1) translate(-20,0)"
                        />
                      </svg>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>
            {renderCallToAction()}
          </div>
        </div>
      </portal-testimonials>
    );
  }
}
